module.exports = __webpack_public_path__ + "static/media/Bluecoronavirus.9d470e89.svg";